import { css } from 'styled-components';
import avenir300woff from '../../../../client/fonts/Avenir/Avenir35Light.woff';
import avenir300woff2 from '../../../../client/fonts/Avenir/Avenir35Light.woff2';
import avenir400woff from '../../../../client/fonts/Avenir/AvenirPro55Roman.woff';
import avenir400woff2 from '../../../../client/fonts/Avenir/AvenirPro55Roman.woff2';
import avenir500woff from '../../../../client/fonts/Avenir/Avenir65Medium.woff';
import avenir500woff2 from '../../../../client/fonts/Avenir/Avenir65Medium.woff2';
import avenir600woff from '../../../../client/fonts/Avenir/AvenirPro85Heavy.woff';
import avenir600woff2 from '../../../../client/fonts/Avenir/AvenirPro85Heavy.woff2';
import avenir700woff from '../../../../client/fonts/Avenir/Avenir95Black.woff';
import avenir700woff2 from '../../../../client/fonts/Avenir/Avenir95Black.woff2';
const avenir = css `


  /* Graphik Compact Light */
  @font-face {
    font-display: swap;
    font-family: 'Avenir';  
    font-weight: 300;
    font-style: normal;
    src: url(${avenir300woff2}) format('woff2'),
      url(${avenir300woff}) format('woff');
  }

  /* Graphik Compact Regular */
  @font-face {
    font-display: swap;
    font-family: 'Avenir';  
    font-weight: 400;
    font-style: normal;
    src: url(${avenir400woff2}) format('woff2'),
      url(${avenir400woff}) format('woff');
  }

  /* Graphik Compact Medium */
  @font-face {
    font-display: swap;
    font-family: 'Avenir';  
    font-weight: 500;
    font-style: normal;
    src: url(${avenir500woff2}) format('woff2'),
      url(${avenir500woff}) format('woff');
  }

  /* Graphik Compact Medium */
  @font-face {
    font-display: swap;
    font-family: 'Avenir';  
    font-weight: 600;
    font-style: normal;
    src: url(${avenir600woff2}) format('woff2'),
      url(${avenir600woff}) format('woff');
  }

  /* Graphik Compact Bold */
  @font-face {
    font-display: swap;
    font-family: 'Avenir';  
    font-weight: 700;
    font-style: normal;
    src: url(${avenir700woff2}) format('woff2'),
      url(${avenir700woff}) format('woff');
  }

`;
export default avenir;
